var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHands2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 152,
    viewBox: "0 0 354 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.964844 124.234C19.8964 135.782 41.255 151 70.0611 151C90.6278 151 111.514 143.493 120.136 124.234C134.342 92.4984 118.003 60.4309 118.003 45.2129",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.42383 70.5255C34.2427 85.1699 63.1382 108.163 75.0694 103.421C98.2165 94.3211 90.3986 64.892 87.1795 53.2044C86.2086 49.6485 83.8326 43.1356 83.1811 39.5031C80.9712 27.3695 88.393 18.8046 103.62 10.6475C111.923 6.19933 122.935 -1.2185 126.154 1.63648C128.798 3.98163 124.749 8.50626 118.285 13.6299C114.407 16.8937 110.346 19.9362 106.124 22.7429",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.228 19.6203C120.648 18.7536 123.893 23.9155 124.033 26.6812C124.251 33.1559 116.598 37.8335 116.598 37.8335C116.598 37.8335 112.51 40.1149 112.025 37.4129C111.539 34.7109 114.58 31.448 114.58 31.448",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.094 43.3777C112.957 40.204 106.902 30.1989 112.229 29.3577C115.844 28.7714 119.102 27.4204 119.063 25.2154C119.063 22.284 114.375 22.1183 113.353 22.0546C109.889 21.8185 106.422 22.4794 103.288 23.9733C100.155 25.4672 97.4616 27.7434 95.4692 30.5813",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.008 27.8789C124.601 28.1635 125.095 28.6195 125.425 29.1877C125.756 29.7559 125.907 30.4101 125.86 31.0653C125.745 32.6839 124.583 35.1056 122.807 38.5086C121.031 41.9116 116.981 44.1293 114.886 40.4204",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.946 132.963C279.306 75.3584 310.877 40.0986 317.959 32.5787C334.876 14.6504 341.025 12.0483 342.915 11.9767C345.224 11.8812 347.7 15.1159 342.688 20.5947C337.902 25.8347 326.908 35.0495 322.35 40.7312",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M333.477 29.5827C338.789 26.5867 341.277 29.153 341.062 32.8891",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M345.38 50.9966C345.703 53.9807 345.057 61.8228 340.116 67.0628C337.855 69.4501 334.254 71.7419 332.615 74.5588C330.354 78.462 312.672 106.727 303.065 140.937",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M335.582 49.8268C337.592 47.3321 342.76 40.2778 345.703 37.8905C347.844 36.1359 351.684 36.5656 352.594 39.0841C353.635 41.9369 352.594 49.8268 350.404 56.4395C349.663 58.6835 345.954 59.6743 345.188 55.8188",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M329.421 45.1594C330.928 43.2854 338.824 34.2973 341.109 33.3066C345.236 31.5043 347.557 34.1064 346.169 37.1621",
    stroke: "#082C4E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHands2);
export default __webpack_public_path__ + "static/media/hands2.274fb7f47ec737c94c509175581f1bc7.svg";
export { ForwardRef as ReactComponent };